(function () {
  function handleClick(event) {
    var link = event.target.closest('a[href*="#ccm-settings"]');
    if (!link) return;

    event.preventDefault();

    if (window.CCM && typeof window.CCM.openWidget === 'function') {
      window.CCM.openWidget();
    } else {
      console.warn('[CCM] Cookie Manager nicht verfügbar');
    }
  }

  document.addEventListener('click', handleClick);
})();
